import { styled } from '@material-ui/core/styles';

import { ICustomTheme } from 'interfaces';

export const StyledContainer = styled('div')(
  ({ isMobile, theme }: { isMobile: boolean; theme: ICustomTheme }) => ({
    backgroundColor: isMobile ? theme.colors.white : 'transparent',
    borderRadius: isMobile ? theme.spacing(5) : 'none',
    boxShadow: isMobile ? theme.shadows[4] : 'none',
    padding: isMobile ? theme.spacing(1) : 'none',
    width: isMobile ? '100%' : theme.spacing(7.5),
    maxWidth: isMobile ? theme.spacing(38) : theme.spacing(7.5),
    position: 'sticky',
    bottom: isMobile ? '5%' : '20%',
    left: isMobile ? 'calc(50% - 152px)' : '100%',
    transform: isMobile ? 'none' : 'translateX(30px)',
    zIndex: 9999,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: theme.spacing(1),
    height: 'auto',
    flexDirection: isMobile ? 'row' : 'column',
    marginTop: isMobile ? theme.spacing(2) : 0,
    flexWrap: 'wrap',
  }),
);
